import { NavLink } from "react-router-dom";
import { useState, useEffect } from "react";
import "./Header.css";

// ✅ MUI Icons
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import PhoneInTalkOutlinedIcon from "@mui/icons-material/PhoneInTalkOutlined";

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [showScrollTop, setShowScrollTop] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      const scrollY = window.scrollY;
      setScrolled(scrollY > 30);
      setShowScrollTop(scrollY > 200);
    };
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <>
      <header className={`modern-header ${scrolled ? "scrolled" : ""}`}>
        <div className="modern-header-inner">
          {/* BRAND + CONTACT */}
          <div className="brand-group">
            <NavLink to="/home" className="brand">
              <img src="/parlogo.png" alt="Parivikshak" className="brand-logo" />
              <div className="brand-text">
                <div className="brand-title">Parivikshak</div>
                <div className="brand-sub">Digitizing Safety</div>
              </div>
            </NavLink>

            {/* ✅ CONTACT INFO */}
            <div className="header-contact">
              <div className="contact-item">
                <EmailOutlinedIcon />
                <span>contact@parivikshak.in</span>
              </div>
              <div className="contact-item">
                <PhoneInTalkOutlinedIcon />
                <span>+91 94820 31400</span>
              </div>
            </div>
          </div>

          {/* NAVIGATION */}
          <nav className="modern-nav">
            {[
              { to: "/home", label: "Home" },
              { to: "/who-we-are", label: "About Us" },
              { to: "/our-values", label: "Our Values" },
              { to: "/platform-features", label: "Platform Features" },
              { to: "/contact-us", label: "Contact Us" }
            ].map((link, i) => (
              <NavLink
                key={i}
                to={link.to}
                className={({ isActive }) =>
                  `nav-link ${isActive ? "active" : ""}`
                }
                end={link.to === "/home"}
              >
                {link.label}
              </NavLink>
            ))}
          </nav>

          {/* ACTION */}
          <div className="header-actions">
            <NavLink to="/login" className="btn-outline">
              Login
            </NavLink>
          </div>
        </div>
      </header>

      {/* SCROLL TO TOP */}
      {showScrollTop && (
        <button className="scroll-to-top" onClick={scrollToTop}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            fill="none"
            stroke="#fff"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
            viewBox="0 0 24 24"
          >
            <polyline points="18 15 12 9 6 15" />
          </svg>
        </button>
      )}
    </>
  );
}
